import { request } from '../request';

// eslint-disable-next-line import/prefer-default-export
export function getUserInfo() {
  return request.get('/user/getUserInfo');
}
